import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import Loader from "../Loader/Loader";
import load from "../../assets/loader.gif";
import { useSearchParams } from "react-router-dom";

const VideoModal = ({ videoData, handleModalClose }) => {
  let [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    setSearchParams({ url: videoData.url });

    return () => {
      window.history.pushState({}, null, window.location.pathname);
    };
  }, [videoData, setSearchParams]);

  return (
    <>
      <div
        onClick={() => handleModalClose()}
        className="overlayContainer"
      ></div>

      <div className="media-modal">
        <div
          style={{
            background: "#000",
            width: "100%",
            height: "100%",
            display: "flex",
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
            zIndex: -1,
          }}
        >
          <Loader />
        </div>

        <ReactPlayer
          config={{
            youtube: {
              playerVars: {
                showinfo: 0,
                controls: 1,
                disablekb: 0,
                enablejsapi: 0,
                modestbranding: 1,
                rel: 0,
                playsinline: 1,
              },
            },
          }}
          playing={true}
          url={videoData.url}
          volume={0.5}
          controls={true}
          width="100%"
          height="100%"
          playsinline={true}
        />

        <div className={"closeIcon"} onClick={handleModalClose}>
          <img src={require("../../assets/images/close.png")} />
        </div>
      </div>
    </>
  );
};

export default VideoModal;
